import { render, staticRenderFns } from "./Topbar.vue?vue&type=template&id=f533cc6c"
import script from "./Topbar.vue?vue&type=script&lang=ts"
export * from "./Topbar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_bef45e0e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f533cc6c')) {
      api.createRecord('f533cc6c', component.options)
    } else {
      api.reload('f533cc6c', component.options)
    }
    module.hot.accept("./Topbar.vue?vue&type=template&id=f533cc6c", function () {
      api.rerender('f533cc6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/Topbar.vue"
export default component.exports